import type { ComponentType } from 'react';

import { FirstPitchIcon } from './FirstPitchIcon';
import { ScorecardCollectorIcon } from './ScorecardCollectorIcon';
import { DedicatedScorerIcon } from './DedicatedScorerIcon';
import { IronScorerIcon } from './IronScorerIcon';
import { TheScorekeeperIcon } from './TheScorekeeperIcon';
import { PerfectAttendanceIcon } from './PerfectAttendanceIcon';
import { SpringTrainingIcon } from './SpringTrainingIcon';
import { HotStreakIcon } from './HotStreakIcon';
import { MonthlyMarathonIcon } from './MonthlyMarathonIcon';
import { OpeningDayTraditionIcon } from './OpeningDayTraditionIcon';
import { WeekendWarriorIcon } from './WeekendWarriorIcon';
import { PencilPuristIcon } from './PencilPuristIcon';
import { PenAndInkIcon } from './PenAndInkIcon';
import { TheCalligrapherIcon } from './TheCalligrapherIcon';
import { ScorebookLoyalistIcon } from './ScorebookLoyalistIcon';
import { TheDetailerIcon } from './TheDetailerIcon';
import { DivisionSweepIcon } from './DivisionSweepIcon';
import { RoadTripIcon } from './RoadTripIcon';
import { RivalryCollectorIcon } from './RivalryCollectorIcon';
import { AroundTheHornIcon } from './AroundTheHornIcon';
import { BallparkPassportIcon } from './BallparkPassportIcon';
import { MultipleRoundTripperIcon } from './MultipleRoundTripperIcon';
import { UltimateNeutralScorekeeperIcon } from './UltimateNeutralScorekeeperIcon';
import { TheGrandTourIcon } from './TheGrandTourIcon';
import { WitnessIcon } from './WitnessIcon';
import { MomentCollectorIcon } from './MomentCollectorIcon';
import { NoHitHistorianIcon } from './NoHitHistorianIcon';
import { PerfectionIcon } from './PerfectionIcon';
import { WalkOffStorytellerIcon } from './WalkOffStorytellerIcon';
import { OctoberScorerIcon } from './OctoberScorerIcon';
import { FirstLikeGivenIcon } from './FirstLikeGivenIcon';
import { FirstLikeReceivedIcon } from './FirstLikeReceivedIcon';
import { TheFollowIcon } from './TheFollowIcon';
import { MvpVoterIcon } from './MvpVoterIcon';
import { CrowdFavoriteIcon } from './CrowdFavoriteIcon';
import { ReactionKingIcon } from './ReactionKingIcon';
import { InfluencerIcon } from './InfluencerIcon';
import { FanFavoriteIcon } from './FanFavoriteIcon';
import { FirstShareIcon } from './FirstShareIcon';
import { SocialScorerIcon } from './SocialScorerIcon';
import { CrossPlatformIcon } from './CrossPlatformIcon';
import { ViralScorecardIcon } from './ViralScorecardIcon';
import { TheAmbassadorIcon } from './TheAmbassadorIcon';
import { TheCloserIcon } from './TheCloserIcon';
import { WorldClassicIcon } from './WorldClassicIcon';
import { HolidayScorerIcon } from './HolidayScorerIcon';
import { TheHistorianIcon } from './TheHistorianIcon';
import { CharterMemberIcon } from './CharterMemberIcon';
import { OneSixtyTwoClubIcon } from './OneSixtyTwoClubIcon';
import { TheLinescoreIcon } from './TheLinescoreIcon';

export const BADGE_ICONS: Record<string, ComponentType> = {
  first_pitch: FirstPitchIcon,
  scorecard_collector: ScorecardCollectorIcon,
  dedicated_scorer: DedicatedScorerIcon,
  iron_scorer: IronScorerIcon,
  the_scorekeeper: TheScorekeeperIcon,
  perfect_attendance: PerfectAttendanceIcon,
  spring_training: SpringTrainingIcon,
  hot_streak: HotStreakIcon,
  monthly_marathon: MonthlyMarathonIcon,
  opening_day_tradition: OpeningDayTraditionIcon,
  weekend_warrior: WeekendWarriorIcon,
  pencil_purist: PencilPuristIcon,
  pen_and_ink: PenAndInkIcon,
  the_calligrapher: TheCalligrapherIcon,
  scorebook_loyalist: ScorebookLoyalistIcon,
  the_detailer: TheDetailerIcon,
  division_sweep: DivisionSweepIcon,
  road_trip: RoadTripIcon,
  rivalry_collector: RivalryCollectorIcon,
  around_the_horn: AroundTheHornIcon,
  ballpark_passport: BallparkPassportIcon,
  multiple_round_tripper: MultipleRoundTripperIcon,
  ultimate_neutral_scorekeeper: UltimateNeutralScorekeeperIcon,
  the_grand_tour: TheGrandTourIcon,
  witness: WitnessIcon,
  moment_collector: MomentCollectorIcon,
  no_hit_historian: NoHitHistorianIcon,
  perfection: PerfectionIcon,
  walk_off_storyteller: WalkOffStorytellerIcon,
  october_scorer: OctoberScorerIcon,
  first_like_given: FirstLikeGivenIcon,
  first_like_received: FirstLikeReceivedIcon,
  the_follow: TheFollowIcon,
  mvp_voter: MvpVoterIcon,
  crowd_favorite: CrowdFavoriteIcon,
  reaction_king: ReactionKingIcon,
  influencer: InfluencerIcon,
  fan_favorite: FanFavoriteIcon,
  first_share: FirstShareIcon,
  social_scorer: SocialScorerIcon,
  cross_platform: CrossPlatformIcon,
  viral_scorecard: ViralScorecardIcon,
  the_ambassador: TheAmbassadorIcon,
  the_closer: TheCloserIcon,
  world_classic: WorldClassicIcon,
  holiday_scorer: HolidayScorerIcon,
  the_historian: TheHistorianIcon,
  charter_member: CharterMemberIcon,
  one_sixty_two_club: OneSixtyTwoClubIcon,
  the_linescore: TheLinescoreIcon,
};
